/* eslint-disable no-undef */
/* eslint-disable no-console */
import axios from "axios";
import { captureException } from "@sentry/react";
import authRefresh from "../utils/helpers/auth-refresh";
import { COUNTRY_CODE } from "../constants/app-constants";
import http from "http";
import https from "https";

const DEBUG = process.env.NODE_ENV === "development";
const agentConfig = { keepAlive: true, maxSockets: 300, maxFreeSockets: 20 };

const axiosInstance = axios.create({
    httpAgent: new http.Agent(agentConfig),
    httpsAgent: new https.Agent(agentConfig),
    headers: {
        "Content-Type": "application/json",
        "X_COUNTRY": COUNTRY_CODE.AU,
        "X_VEHICLE_TYPE": "CAR"
    }
});

axiosInstance.interceptors.request.use(authRefresh, (error) => {
    if (DEBUG) console.error("✉️ ", error);
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
    (response) => {
        if (DEBUG) console.debug("📩 ", response);
        return response;
    },
    (error) => {
        captureException(error);
        if (error.response?.data) {
            if (DEBUG) console.error("Error: ", error.response.data);
            return Promise.reject(error.response.data);
        }
        if (DEBUG) console.error("📩 ", error);
        return Promise.reject(error);
    }
);

export default axiosInstance;
